// extracted by mini-css-extract-plugin
export var container = "_p8-0";
export var dotAnimation = "_p8-2";
export var dotsLoading = "_p8-1";